import { ref } from 'vue'

export function useEffects() {
  const currentEffect = ref(null)
  const effectIntervals = ref({})
  
  const createStars = (container) => {
    if (!container) return
    
    container.innerHTML = ''
    
    for (let i = 0; i < 100; i++) {
      const star = document.createElement('div')
      star.className = 'star'
      
      // 随机大小
      const size = Math.random()
      if (size > 0.8) {
        star.classList.add('large')
      } else if (size < 0.3) {
        star.classList.add('small')
      }
      
      // 随机位置
      star.style.left = Math.random() * 100 + '%'
      star.style.top = Math.random() * 100 + '%'
      
      // 随机动画延迟
      star.style.animationDelay = Math.random() * 3 + 's'
      
      container.appendChild(star)
    }
  }
  
  const createRain = (container) => {
    if (!container) return
    
    for (let i = 0; i < 5; i++) {
      const drop = document.createElement('div')
      drop.className = 'raindrop'
      
      // 从屏幕上方外侧开始，随机水平位置
      drop.style.left = Math.random() * 100 + '%'
      drop.style.top = '-30px'
      drop.style.animationDuration = (Math.random() * 0.5 + 0.5) + 's'
      drop.style.animationDelay = Math.random() * 2 + 's'
      
      container.appendChild(drop)
      
      // 雨滴完成动画后移除
      setTimeout(() => {
        if (container.contains(drop)) {
          container.removeChild(drop)
        }
      }, 3000)
    }
  }
  
  const createSnow = (container) => {
    if (!container) return
    
    for (let i = 0; i < 3; i++) {
      const flake = document.createElement('div')
      flake.className = 'snowflake'
      flake.innerHTML = ['❄', '❅', '❆'][Math.floor(Math.random() * 3)]
      
      // 从屏幕上方外侧开始，随机水平位置
      flake.style.left = Math.random() * 100 + '%'
      flake.style.top = '-30px'
      flake.style.animationDuration = (Math.random() * 3 + 2) + 's'
      flake.style.animationDelay = Math.random() * 2 + 's'
      flake.style.fontSize = (Math.random() * 0.5 + 0.8) + 'rem'
      
      container.appendChild(flake)
      
      // 雪花完成动画后移除
      setTimeout(() => {
        if (container.contains(flake)) {
          container.removeChild(flake)
        }
      }, 5000)
    }
  }
  
  const toggleEffect = (effectName, containers) => {
    // 如果 effectName 为 null 或空字符串，直接关闭当前特效
    if (!effectName) {
      if (currentEffect.value) {
        const prevContainer = containers[currentEffect.value]
        if (prevContainer) {
          prevContainer.classList.remove('active')
          
          // 停止之前的特效循环
          if (effectIntervals.value[currentEffect.value]) {
            clearInterval(effectIntervals.value[currentEffect.value])
            delete effectIntervals.value[currentEffect.value]
          }
          
          // 清空之前的容器（除了星空）
          if (currentEffect.value !== 'stars') {
            setTimeout(() => {
              prevContainer.innerHTML = ''
            }, 500)
          }
        }
        currentEffect.value = null
      }
      return
    }
    
    const container = containers[effectName]
    if (!container) return
    
    // 如果点击的是当前激活的特效，则关闭它
    if (currentEffect.value === effectName) {
      // 关闭当前特效
      container.classList.remove('active')
      
      // 停止特效循环
      if (effectIntervals.value[effectName]) {
        clearInterval(effectIntervals.value[effectName])
        delete effectIntervals.value[effectName]
      }
      
      // 清空容器（除了星空）
      if (effectName !== 'stars') {
        setTimeout(() => {
          container.innerHTML = ''
        }, 500)
      }
      
      currentEffect.value = null
      return
    }
    
    // 关闭之前的特效
    if (currentEffect.value) {
      const prevContainer = containers[currentEffect.value]
      if (prevContainer) {
        prevContainer.classList.remove('active')
        
        // 停止之前的特效循环
        if (effectIntervals.value[currentEffect.value]) {
          clearInterval(effectIntervals.value[currentEffect.value])
          delete effectIntervals.value[currentEffect.value]
        }
        
        // 清空之前的容器（除了星空）
        if (currentEffect.value !== 'stars') {
          setTimeout(() => {
            prevContainer.innerHTML = ''
          }, 500)
        }
      }
    }
    
    // 激活新的特效
    currentEffect.value = effectName
    container.classList.add('active')
    
    // 开始新的特效循环
    if (effectName === 'rain') {
      effectIntervals.value.rain = setInterval(() => createRain(container), 200)
    } else if (effectName === 'snow') {
      effectIntervals.value.snow = setInterval(() => createSnow(container), 500)
    }
  }
  
  const initEffects = (starsContainer) => {
    createStars(starsContainer)
  }
  
  const cleanup = () => {
    Object.values(effectIntervals.value).forEach(interval => {
      clearInterval(interval)
    })
    effectIntervals.value = {}
  }
  
  return {
    currentEffect,
    effectIntervals,
    toggleEffect,
    initEffects,
    cleanup
  }
}